import { FileUploadState } from "../types";




export const initialState: FileUploadState = {
  loading: false
};
